<template>
  <TheModal class="modal-enter" v-model:show="showModal">
    <div class="enter__body modal__body center">
      <div class="modal__close center" @click="setShowLoginModal(false)">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.33333 5.33398L26.6667 26.6673M26.6667 5.33398L5.33333 26.6673" stroke="white" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <LoginForm/>
    </div>
  </TheModal>
</template>

<script>
import TheModal from "@/components/TheModal.vue";
import {mapMutations, mapState} from "vuex";
import LoginForm from "@/components/form/LoginForm.vue";

export default {
  name: 'TheLoginModal',
  components: {LoginForm, TheModal},
  computed: {
    showModal: {
      get() {
        return this.showLoginModal;
      },
      set(value) {
        this.setShowLoginModal(value)
      }
    },
    ...mapState({
      'showLoginModal': state => state.showLoginModal,
    }),
  },
  methods: {
    ...mapMutations({
      'setShowLoginModal': 'setShowLoginModal',
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>